// src/components/dashboard/DashboardHeader.js

import { useMemo } from 'react';

const DashboardHeader = ({ toLearnToday, toReviewNow }) => {
  const customMessage = useMemo(() => {
    if (toReviewNow > 0) {
      return (
        <>
          You have <span className="text-primary font-bold">{toReviewNow}</span> item{toReviewNow > 1 ? 's' : ''} ready for review.
        </>
      );
    }
    if (toLearnToday > 0) {
      return (
        <>
          Time to learn <span className="text-primary font-bold">{toLearnToday}</span> new sentence{toLearnToday > 1 ? 's' : ''}!
        </>
      );
    }
    return "You're all caught up. Great work!";
  }, [toLearnToday, toReviewNow]);

  return (
    <div className="animate-fade-in">
      <h1 className="text-3xl lg:text-4xl font-black text-content-primary leading-tight">Welcome back!</h1>
      <p className="text-base lg:text-lg text-content-secondary font-medium opacity-90">{customMessage}</p>
    </div>
  );
};

export default DashboardHeader;
